export function formatUserType(type) {
  if (!type || typeof type !== "string") return "";

  return type
    .toLowerCase()              // super_admin
    .split("_")                 // ['super', 'admin']
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // ['Super', 'Admin']
    .join(" ");                 // 'Super Admin'
}
